import { TCommissionState, TCustomerCommissionState } from '../schemas';

export const COMMISSION_STATE_TO_ORDER: Record<TCommissionState, number> = {
    ENQUIRY_FROM_WEBSITE: 0,
    ENQUIRY_FROM_CUSTOMER_ZONE: 1,
    CREATED: 2,
    ACCEPTED: 3,
    WAITING_FOR_OFFERS: 4,
    WAITING_FOR_PRICE_APPROVAL: 5,
    WAITING_FOR_OFFERS_FOR_CUSTOMER: 6,
    WAITING_FOR_CUSTOMER_APPROVAL: 7,
    CARRIER_ASSIGNED: 8,
    ORDER_SENT: 9,
    IN_PROGRESS: 10,
    COMPLETED: 11,
    IN_CLAIM: 12,
    CANCELLED: 13,
    CANCELLATION_APPROVAL: 14,
    CANCELLED_WITH_FAILED_ATTEMPT: 15,
};

export const CUSTOMER_COMMISSION_STATE_TO_ORDER: Record<TCustomerCommissionState, number> = {
    ENQUIRY: 0,
    PROCESSING: 1,
    WAITING_FOR_OFFERS: 2,
    WAITING_FOR_APPROVAL: 3,
    VEHICLE_ASSIGNED: 4,
    IN_PROGRESS: 5,
    COMPLETED: 6,
    IN_CLAIM: 7,
    CANCELLED: 8,
    CANCELLATION_APPROVAL: 9,
    CANCELLED_WITH_FAILED_ATTEMPT: 10,
};
